import { render, staticRenderFns } from "./message-type-selector.vue?vue&type=template&id=d0db38dc&scoped=true"
import script from "./message-type-selector.vue?vue&type=script&lang=js"
export * from "./message-type-selector.vue?vue&type=script&lang=js"
import style0 from "./message-type-selector.vue?vue&type=style&index=0&id=d0db38dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0db38dc",
  null
  
)

export default component.exports